import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Formsy from 'formsy-react';
import { trim } from 'lodash'
import { Input as TWInput, Switch, SheetFooter, Row, Col, Button, Label, FormGroup, Tabs, TabsContent, TabsList, TabsTrigger, SimpleAlert, SheetBody } from 'twyne-new.ui'

import Input from 'components/form/Input';
import Select from 'components/form/Select';

import SiteVerifications from './Verifications';
import DomainAliases from './DomainAliases';
import InfoTip from '@Components/InfoTip';
import { useSiteStore } from '../store';
import Duplicated, { DEFAULT_DUPLICATE_LEAD, DEFAULT_DUPLICATE_LEAD_DAYS, DEFAULT_DUPLICATE_CLICK_DAYS } from '@Modules/offer/views/allocation/components/Duplicated';

class SiteForm extends React.Component {
  state = {
    domain_aliases: '',
    domain: null,
    embed: false
  };

  componentDidMount() {
    const data = this.props.data;
    if (data) {
      this.setState({ ...data, embed: data.viewdir === 'embed' });
    }
  }

  handleEmbed = () => {
    const embed = !this.state.embed;
    const viewdir = embed ? 'embed' : '';
    this.setState({ embed, viewdir });
  }

  handleValidSubmit = (model) => {
    Object.assign(this.state, model)
    this.state.domain_aliases = aliases.putInQuotes(this.state.domain_aliases)
    this.props.onSubmit(this.state);
  }

  handleChangeVerifications = (cmsVerificationsSites) => {
    this.setState({ cmsVerificationsSites })
  }

  Verifications = () => {
    return <SiteVerifications data={this.state.cmsVerificationsSites} onChange={this.handleChangeVerifications} />
  }

  handleMeta = meta => {
    this.setState(prevState => ({ meta: { ...prevState.meta, ...meta } }));
  }

  Duplicateds = () => {
    const { duplicateClick, meta } = this.state
    const { duplicateLead } = meta || {}
    const { rules } = duplicateLead || {}

    const handleChangeData = rules => {
      const metaProps = meta || {}
      const leadProps = duplicateLead || {}
      this.setState({ meta: { ...metaProps, duplicateLead: { ...leadProps, rules } } })
    }

    return <Row>
      <Col size="12">
        <Duplicated
          title="Settings for duplicate clicks"
          fieldName="duplicate_click_days"
          fieldValue={duplicateClick}
          onChange={duplicateClick => this.setState({ duplicateClick })}
        >
          <SimpleAlert>
            The default settings for duplicated click is {DEFAULT_DUPLICATE_CLICK_DAYS} day{DEFAULT_DUPLICATE_CLICK_DAYS <= 1 ? '' : 's'}.
          </SimpleAlert>
        </Duplicated>
      </Col>
      <Col size="12">
        <Duplicated
          title="Settings for duplicate leads"
          fieldName="duplicateLead"
          fieldValue={rules}
          onChange={handleChangeData}
        >
          <SimpleAlert>
            The default settings for duplicated leads is configured to mark as duplicated {DEFAULT_DUPLICATE_LEAD} within the {DEFAULT_DUPLICATE_LEAD_DAYS} days.
          </SimpleAlert>
        </Duplicated>
      </Col>
    </Row>
  }

  Properties = () => {
    const [organizations, setOrganizations] = useState([])
    const { lists: { organizations: { items, useLoad } } } = useSiteStore()

    useLoad()
    useEffect(() => {
      setOrganizations(items?.map(({ id, name }) => ({ value: id, label: name })))
    }, [items])

    return <Row>
      <Col size="4">
        <FormGroup>
          <Label>Site Name</Label>
          <Input name="name" value={this.state.name || ''} required />
        </FormGroup>
      </Col>
      <Col size="4">
        <FormGroup>
          <Label>Domain</Label>
          <Input name="domain" value={this.state.domain || ''} required disabled />
        </FormGroup>
      </Col>
      <Col size="4">
        <FormGroup>
          <Label>Site Organization</Label>
          <Select required name="organizationId" options={organizations} value={this.state.organizationId} />
        </FormGroup>
      </Col>
      {!this.state.embed ? <>
        <Col size="4">
          <FormGroup>
            <Label>Viewdir</Label>
            <Input name="viewdir" value={this.state.viewdir || ''} required />
          </FormGroup>
        </Col>
      </> : null}
      <Col size="4">
        <FormGroup>
          <Label>
            Registration Delay<small>(minutes)</small>
            <InfoTip id="registration-delay-tip" color='accent' side={this.state.embed ? 'left' : 'right'} contentProps={{ className: 'max-w-48' }}>
              This flag dictates the expiration time on the registration integration. <br /> The range in this config is 1 to 60 minutes.
            </InfoTip>
          </Label>
          <TWInput type="number" value={this.state.meta?.registrationDelay || 8} onChange={({ target: { value } }) => this.handleMeta({ registrationDelay: value > 60 ? 60 : value < 1 ? 1 : value })} /><em />
        </FormGroup>
      </Col>
      <Col size="4">
      </Col>
      <Col size="4">
        <FormGroup>
          <Label>Midpath Pre-flight</Label>
          <Switch value={this.state.meta?.preflight} onChange={() => this.handleMeta({ preflight: !this.state.meta?.preflight })} />
        </FormGroup>
      </Col>
      <Col size="4">
        <FormGroup>
          <Label>Embed</Label>
          <Switch value={this.state.embed} onChange={this.handleEmbed} />
        </FormGroup>
      </Col>
      <Col size="4">
        <FormGroup>
          <Label>Active</Label>
          <Switch value={this.state.active} onChange={() => this.setState({ active: !this.state.active })} />
        </FormGroup>
      </Col>
      <Col size="12">
        <FormGroup>
          <DomainAliases
            value={this.state.domain_aliases}
            domain={this.state.domain}
            onChange={domain_aliases => this.setState({ domain_aliases })}
            onChangeDefault={domain => this.setState({ domain })}
          />
        </FormGroup>
      </Col>
    </Row>
  }

  Tabs = () => {
    if (!this.state.cmsVerificationsSites) {
      return <this.Properties />
    }

    return <Tabs defaultValue='properties'>
      <TabsList>
        <TabsTrigger className='pt-0' value='properties'>Properties</TabsTrigger>
        <TabsTrigger className='pt-0' value='verifications'>Verifications</TabsTrigger>
        <TabsTrigger className='pt-0' value='duplicateds'>Duplicateds</TabsTrigger>
      </TabsList>
      <TabsContent value='properties'>
        <this.Properties />
      </TabsContent>
      <TabsContent value='verifications'>
        <this.Verifications />
      </TabsContent>
      <TabsContent value='duplicateds'>
        <this.Duplicateds />
      </TabsContent>
    </Tabs>
  }

  render() {
    return (
      <Formsy onValidSubmit={this.handleValidSubmit}>
        <SheetBody>
          <this.Tabs />
        </SheetBody>
        <SheetFooter>
          <Button onClick={() => this.props.onClose()} variant='ghost'>Cancel</Button>
          <Button type="submit" color="accent">Save</Button>
        </SheetFooter>
      </Formsy>
    );
  }
}

SiteForm.propTypes = {
  handleSubmit: PropTypes.func,
  data: PropTypes.any
};

const aliases = new class {
  constructor() {
    return {
      stripQuotes: astring => {
        return astring && astring.split(',').map(this.stripQuotes.bind(this)).join(',')
      },
      putInQuotes: astring => {
        return astring && astring.split(',').map(this.putInQuotes.bind(this)).join(',')
      }
    }
  }

  stripQuotes(s) {
    return trim(s.trim(), '"')
  }

  putInQuotes(s) {
    return `"${this.stripQuotes(s)}"`
  }
}
export default SiteForm;
